export default {
    earlyWithdrawalRate: 2,
    dateFormat: 'YYYY-MM-DD HH:mm',
    fileTemplatePath: "https://parceldaily-public.s3.ap-southeast-1.amazonaws.com/admin-templates",
    s3Folder: {
        issueAttachment: "issueAttachment",
    }
}